export const breadcrumbActualizacionDeuda = [
    { label: 'Inicio', url: '/' },
    { label: 'Reportes', url: `/reportes` },
    { label: 'Actualización de Deuda', active: true },
]